import React from 'react';
import events from '../../lib/events.js';
import notificationsApi from '../../api/notification.jsx';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

const INTERVALS = {
  // when the user is active
  active: 60 * 1000, // ms
  // when the user hasn't clicked in a while
  idle: 10 * 60 * 1000, // ms
};
// Consider the user idle after this amount of time
const IDLE_TIME = 5 * 60 * 1000; // ms

// Component
class HeaderAlerts extends React.Component {
  static displayName = 'HeaderAlerts';
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    notifications: [],
    unread: 0,
    open: false,
  };

  componentDidMount() {
    this.fetchCount();
    this.notificationListener = events.subscribe('notification-change', this.fetch);
    this.clickListener = events.subscribe('click', this.onClick);

    this.waitToFetch();
  }

  //Avoid re-render navbar after every click within website window
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.intl !== nextProps.intl ||
      this.props.intl && nextProps.intl && this.props.intl.locale !== nextProps.intl.locale  ||
      this.state.unread !== nextState.unread ||
      this.state.open !== nextState.open ||
      this.state.notifications.length !== nextState.notifications.length;
  }

  componentWillUnmount() {
    this.notificationListener.remove();
    this.clickListener.remove();
  }

  onClick = () => {
    // prevent click from opening the popup to automatically close it right after
    if (Date.now() - this.lastClick > 30) {
      this.close();
    }

    this.lastClick = Date.now();
  };

  clickListener =  null;

  close = () => {
    this.setState({open: false});
  };

  fetch = () => {
    notificationsApi.unread()
      .then(notifications => this.setState({
        notifications: notifications,
        unread: notifications.filter(n => !n.read),
      }))
      .catch(e => console.error(e));
  };

  fetchCount = () => {
    notificationsApi.unreadCount()
      .then(unread => this.setState({unread: unread}))
      .catch(e => console.error(e));
  };

  lastClick =  Date.now();

  linkToNotification = id => {
    window.location.hash = `#notifications/${id}`;
  };

  notificationListener =  null;

  open = () => {
    this.setState({open: true, notifications: []});
    this.fetch();

    // Used to detect when click is opening the notifications popup to prevent
    // the popup from immediately closing after being opened
    this.lastClick = Date.now();
  };

  toggle = () => {
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  };

  waitToFetch = () => {
    // poll for updates
    let interval;

    if (Date.now() - this.lastClick > IDLE_TIME) {
      interval = INTERVALS.idle;
    } else {
      interval = INTERVALS.active;
    }
    setTimeout(() => {
      this.fetchCount();
      this.waitToFetch();
    }, interval);
  };

  render() {
    const {intl} = this.props;
    const notifications = this.state.notifications;
    const unread = this.state.unread;
    const badge = unread > 0 ? <span className='badge'>{unread}</span> : null;

    let notificationList;

    if (notifications.length > 0) {
      notificationList = this.state.notifications.filter(n => !n.read).slice(0, 3).map(n => {
        const title = intl.locale.includes('fr') ? n.titleFr || n.title : n.title || n.titleFr;
        const body = intl.locale.includes('fr') ? n.bodyFr || n.body : n.body || n.bodyFr;

        return <div key={n.id}
                    className='notification-list-item notification-list-item-hover'
                    onClick={this.linkToNotification.bind(this, n.id)}>
          <p className='title'><FormattedMessage id={n.type}/></p>
          <p className='subject'>{title}</p>
          <p className='description'>{body}</p>
          <date className='date'>{n.created.fromNow()}</date>
          <i className='fa fa-chevron-right'/>
        </div>;
      });
    } else {
      notificationList =
        <div key='no-new' className='notification-list-item'>
          <p className='no-new'><FormattedMessage id="navbar.alerts.no.notifications" /></p>
        </div>
      ;
    }

    let dropdown = null;

    if (this.state.open) {
      dropdown =
        <div className='header-alerts-dropdown'>
          {notificationList}
          <div className='view-all-link text-center'>
            <a href='/#notifications'><FormattedMessage id="navbar.alerts.all.notifications" /></a>
          </div>
        </div>
      ;
    }

    const bellStyle = {
      display: 'inline-block',
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingLeft: '20px',
      paddingRight: '40px',
      marginTop: '-20px',
      marginBottom: '-20px',
      marginLeft: '-20px',
      marginRight: '-40px',
    };

    return <a className='header-alerts'
              id='header-alerts'>
      <i className='icon bl bl-alerts'
         style={bellStyle}
         onClick={this.toggle}/>
      {badge}
      {dropdown}
    </a>;
  }
}

export default injectIntl(HeaderAlerts);
